import { Injectable, EventEmitter } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { StartFunctionResponseModel } from '../../model/startFunctionResponseModel';

@Injectable()
export class StartFunctionService {
  private subject = new Subject<any>();

  private notifyStepInProgress : EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  sendStartFunctionBrokerResp(startFunctionResp:StartFunctionResponseModel) {
    this.subject.next(startFunctionResp);
}

clearStartFunctionBrokerResp() {
    this.subject.next(null);
}

getStartFunctionBrokerResp(): Observable<any> {
    return this.subject.asObservable();
}

getNotifyStepInProgress(){
    return this.notifyStepInProgress;
}
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/start-function.service.ts